module.exports = __webpack_public_path__ + "media/step2_animation.c45aea03.webm";